module.exports = __webpack_public_path__ + "img/IconGrupo.f0d8e54c.svg";